<div class="reset-wrapper">
  <div class="reset-card">
    <div class="reset-header">
      <img src="../assets/images/Smee&Ford-Web-Logo-RGB-white-on-transparent.png" class="reset-logo" alt="Smee &amp; Ford" />
      <h2>Charity Central</h2>
      <p class="reset-subtitle">Client Portal</p>
    </div>

    @if(view === 'form') {
      <div class="reset-body">
        <p class="reset-intro">Choose a new password for your account.</p>
        <div class="reset-form-row">
          <label>New password</label>
          <input type="password" [(ngModel)]="newPassword" placeholder="At least 6 characters" [disabled]="loading" />
        </div>
        <div class="reset-form-row">
          <label>Confirm new password</label>
          <input type="password" [(ngModel)]="confirmPassword" (keyup.enter)="submit()" placeholder="Repeat your password" [disabled]="loading" />
        </div>
        @if(validationError) {
          <div class="reset-error">{{ validationError }}</div>
        }
        <button class="reset-btn" (click)="submit()" [disabled]="loading || !newPassword || !confirmPassword">
          {{ loading ? 'Saving...' : 'Set New Password' }}
        </button>
      </div>
    }

    @if(view === 'success') {
      <div class="reset-body">
        <div class="reset-outcome reset-success">
          <mat-icon>check_circle</mat-icon>
          <p>Your password has been reset successfully.</p>
        </div>
        <button class="reset-btn" (click)="goToLogin()">Go to Sign In</button>
      </div>
    }

    @if(view === 'error') {
      <div class="reset-body">
        <div class="reset-outcome reset-error-box">
          <mat-icon>error_outline</mat-icon>
          <p>{{ errorMessage }}</p>
        </div>
        <button class="reset-btn" (click)="goToLogin()">Back to Sign In</button>
      </div>
    }

  </div>
</div>
